const urlMimeType = (url) => {
  const parts = url.split(';');
  const mimeType = parts[0].split(':')[1];
  return mimeType;
};

export default urlMimeType;
